import(/* webpackMode: "eager" */ "/opt/chadai.org/src/app/page.tsx");
